import { render, staticRenderFns } from "./c_menu_list.vue?vue&type=template&id=f3c9274e&scoped=true"
import script from "./c_menu_list.vue?vue&type=script&lang=js"
export * from "./c_menu_list.vue?vue&type=script&lang=js"
import style0 from "./c_menu_list.vue?vue&type=style&index=0&id=f3c9274e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c9274e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3c9274e')) {
      api.createRecord('f3c9274e', component.options)
    } else {
      api.reload('f3c9274e', component.options)
    }
    module.hot.accept("./c_menu_list.vue?vue&type=template&id=f3c9274e&scoped=true", function () {
      api.rerender('f3c9274e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_menu_list.vue"
export default component.exports